import { Modal, Table } from 'antd';
import PropTypes from 'prop-types';
import { CreateModalWrapper, ModalCloseBox } from '../employees/EmployeesStyle';
import { ModalCloseIcon } from '../../theme/SvgIcons';
import dayjs from 'dayjs';
import { activeStatusTag } from '../../utils/common_functions';
import { projectStatusOption } from '../../utils/constant';
import { useEffect, useState } from 'react';
import { GetBillingIdsProjects } from '../../redux/billingIds/apiRoute';

const ProjectsListingModal = ({ open, onClose, selectedId }) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [sort, setSort] = useState({});
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
    showSizeChanger: false,
    hideOnSinglePage: true
  });

  const handleSorting = (val) => {
    if (val?.field) {
      let order = val?.order == 'ascend' ? 'ASC' : 'DESC';
      setSort({ sortBy: val?.field, orderBy: order, ...val });
    } else {
      setSort({});
    }
  };

  const handleTableChange = (newPagination, filters, sorter) => {
    setPagination({
      ...pagination,
      current: newPagination.current
    });
    handleSorting(sorter);
  };

  const handleGetList = async (id) => {
    try {
      setLoading(true);
      let params = new URLSearchParams();
      params.append('hiredId', id);
      params.append('page', pagination?.current);
      params.append('limit', pagination?.pageSize);
      sort?.sortBy && params.append('sortBy', sort?.sortBy);
      sort?.orderBy && params.append('sortOrder', sort?.orderBy);

      let res = await GetBillingIdsProjects(params);
      if (res?.statusCode === 200) {
        setData(res?.data?.list);
        setPagination({
          ...pagination,
          total: res?.data?.total
        });
      } else {
        toast.error(res?.message || 'Something went wrong');
      }
    } catch (error) {
      toast.error(error?.message || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    selectedId && handleGetList(selectedId?.id);
  }, [selectedId, sort]);

  const columns = [
    {
      title: 'S.NO',
      dataIndex: 'key',
      key: 'key',
      render: (_, __, index) => {
        const serialNumber = (pagination?.current - 1) * pagination?.pageSize + index + 1;
        return <span>{serialNumber}.</span>;
      }
    },
    {
      title: 'Project Name',
      dataIndex: 'name',
      key: 'name',
      sorter: true
    },
    {
      title: 'Client Name',
      dataIndex: 'client',
      key: 'client',
      render: (text) => text?.name || 'N/A'
    },
    {
      title: 'Start Date',
      dataIndex: 'start_date',
      key: 'start_date',
      sorter: true,
      render: (text) => (text ? dayjs(text).format('DD MMM, YYYY') : 'N/A')
    },
    {
      title: 'Deadline',
      dataIndex: 'deadline',
      key: 'deadline',
      sorter: true,
      render: (text) => (text ? dayjs(text).format('DD MMM, YYYY') : 'N/A')
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      sorter: true,
      render: (status) => activeStatusTag(projectStatusOption, 'value', status)
    }
  ];

  return (
    <Modal
      open={open}
      onCancel={onClose}
      centered
      width={800}
      footer={null}
      closeIcon={false}
      prefixCls="create-employees">
      <CreateModalWrapper>
        <ModalCloseBox onClick={onClose}>
          <ModalCloseIcon />
        </ModalCloseBox>
        <Table
          prefixCls="antCustomTable"
          columns={columns}
          dataSource={data}
          pagination={pagination}
          onChange={handleTableChange}
          defaultSortOrder={sort.order}
          loading={loading}
        />
      </CreateModalWrapper>
    </Modal>
  );
};

ProjectsListingModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  selectedId: PropTypes.any
};

export default ProjectsListingModal;
